import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import './styles/liquidGlass.css'
// Importé après App pour passer après les feuilles de composants dans la cascade.
import './styles/responsive.css'
import { installDevMeasure } from './devMeasure'
import { applyStandaloneClass, registerCamitServiceWorker } from './utils/registerPwa'

installDevMeasure()
applyStandaloneClass()
registerCamitServiceWorker()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Refetch automatiquement quand la fenêtre reprend le focus
      refetchOnWindowFocus: true,
      // Refetch automatiquement quand le composant est monté
      refetchOnMount: true,
      // Conserver le cache des requêtes inactives 15 min (évite paniers manquants / chargement vacant
      // dans la section réseau social après une période passée sur d'autres onglets)
      gcTime: 15 * 60 * 1000,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)









































